import Icon from '@/components/ui/AppIcon';
import { useLanguage } from '@/contexts/LanguageContext';

export default function ValuesSection() {
  const { t } = useLanguage()

  const checkItems = {
    en: [
      'Premium wild seafood',
      'Professional service',
      'Reliable partners',
      'Fast response',
      'Consistent quality',
    ],
    fr: [
      'Produits sauvages premium',
      'Service professionnel',
      'Partenaires fiables',
      'Réactivité commerciale',
      'Qualité constante',
    ],
  };

  const { language } = useLanguage();
  const items = language === 'fr' ? checkItems?.fr : checkItems?.en;

  return (
    <section id="values" className="py-24 px-6 md:px-12 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center mb-16 reveal">
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-foreground mb-6">
            {t('values.title')}
          </h2>
          <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
            {t('values.subtitle')}
          </p>
        </div>

        {/* Values Grid - 5 checkmark items */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-6 justify-items-center">
          {items?.map((item, index) => (
            <div
              key={index}
              className="reveal card-hover bg-card border border-border rounded-2xl p-6 text-center w-full group"
              style={{ transitionDelay: `${index * 100}ms` }}
            >
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 mx-auto group-hover:bg-primary transition-colors">
                <Icon name="CheckIcon" size={24} className="text-primary group-hover:text-white transition-colors" />
              </div>
              <p className="font-semibold text-foreground text-sm leading-snug">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}